export default [
    {
        key: 'ios',
        icon: require('../images/download_icon_ios@2x.png'),
        value: 'ios端下载',
        image: ''
    },
    {
        key: 'android',
        icon: require('../images/download_icon_android@2x.png'),
        value: 'Android端下载',
        image: ''
    },
]
